export default __webpack_public_path__ + "static/media/rakesh.53222df8.jpg";